export const backend_url = 'http://localhost:5001';
// export const backend_url = 'https://cosmetic-backend-io.onrender.com';
